<!-- One CI glass surface for the whole modal (alphalearn-ci.css). The old
     dialog glass in styles.scss skips cards that carry `.al-glass`, so this
     dialog has exactly one soft outer edge and no 1.5px white frame. -->
<nb-card
  class="form moodle-connect-card al-glass al-glass--quiet"
  [class.form--wide]="hasMoodleSites"
>
  <nb-card-header>
    <div class="dialog-head">
      <h4>{{ "dialogs.moodleConnect.title" | translate }}</h4>
      <div class="dialog-head__subtitle">
        {{ "dialogs.moodleConnect.subtitle" | translate }}
      </div>
    </div>
    <div *ngIf="moodleSitesPollActive" class="moodle-poll-indicator">
      <nb-spinner status="primary" size="tiny"></nb-spinner>
      <span>
        {{
          "dialogs.moodleConnect.pollingForToken" | translate:{
            count: moodleSitesPollDisplayCount
          }
        }}
      </span>
    </div>
    <button
      type="button"
      class="al-icon-button dialog-close"
      [nbTooltip]="'buttons.close' | translate"
      [attr.aria-label]="'buttons.close' | translate"
      (click)="close()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body>
    <!-- Loading -->
    <div *ngIf="loading" class="loading-state">
      <nb-spinner status="primary" size="medium"></nb-spinner>
    </div>

    <div *ngIf="!loading && showMoodleSitesSection && moodleSitesLoading && !hasMoodleSites" class="loading-state">
      <nb-spinner status="primary" size="small"></nb-spinner>
    </div>

    <!-- Moodle plugin sites -->
    <div *ngIf="!loading && showMoodleSitesSection && (!moodleSitesLoading || hasMoodleSites)" class="connected-state">
      <div *ngIf="!moodleSitesLoading && !hasMoodleSites" class="status-row status-row--secondary">
        <nb-icon icon="info-outline" status="basic"></nb-icon>
        <div>
          <p class="status-label">{{ "dialogs.moodleConnect.connectedSites" | translate }}</p>
          <p class="status-url">
            {{
              'dialogs.moodleConnect.noConnectedSites' | translate
            }}
          </p>
        </div>
      </div>

      <!-- Modal → instance surface → flat setting rows (spec §22). State is
           carried by the dot + chips and a faint tint, never a side rail. -->
      <div *ngIf="hasMoodleSites" class="moodle-sites-grid">
        <section
          *ngFor="let site of moodleSites; trackBy: trackMoodleSiteById"
          class="moodle-site-row"
          [class.is-primary-row]="site.is_primary"
          [class.is-connected]="siteNbStatus(site) === 'success'"
          [class.is-disconnected]="isSiteDisconnected(site)"
          [class.is-primary-transition]="primaryTransitionSiteId === site.id"
        >
          <div class="moodle-site-tile__header">
            <nb-icon class="moodle-site-tile__globe" icon="globe-outline"></nb-icon>
            <div class="moodle-site-tile__identity-wrap">
              <a
                class="moodle-site-tile__identity"
                [href]="site.moodle_site_url"
                target="_blank"
                rel="noopener noreferrer"
                [nbTooltip]="'dialogs.moodleConnect.openInstanceTooltip' | translate"
                nbTooltipPlacement="top"
              >
                <span class="moodle-site-tile__domain">
                  <span class="moodle-site-tile__domain-text">{{ displayMoodleDomain(site) }}</span>
                  <nb-icon icon="external-link-outline"></nb-icon>
                </span>
                <span class="moodle-site-tile__url">{{ site.moodle_site_url }}</span>
              </a>
            </div>
            <span
              class="moodle-site-tile__status-dot"
              [class.is-connected]="siteNbStatus(site) === 'success'"
              [class.is-warning]="siteNbStatus(site) === 'warning'"
              [class.is-danger]="siteNbStatus(site) === 'danger'"
              [attr.aria-label]="siteStatusKey(site) | translate"
              role="status"
            ></span>
          </div>

          <div class="moodle-site-row__meta">
            <span
              class="state-chip state-chip--status"
              [class.is-connected]="siteNbStatus(site) === 'success'"
              [class.is-warning]="siteNbStatus(site) === 'warning'"
              [class.is-danger]="siteNbStatus(site) === 'danger'"
            >
              {{ siteStatusKey(site) | translate }}
            </span>
            <span *ngIf="site.is_primary" class="state-chip is-primary">
              {{ "dialogs.moodleConnect.primarySite" | translate }}
            </span>
            <span *ngIf="site.plugin_version" class="state-chip">
              {{ "dialogs.moodleConnect.pluginVersion" | translate }} {{ site.plugin_version }}
            </span>
          </div>

          <div
            *ngIf="siteInfoMessageKey(site) as infoKey"
            class="moodle-site-info"
            [class.moodle-site-info--warning]="siteInfoStatus(site) === 'warning'"
            [class.moodle-site-info--danger]="siteInfoStatus(site) === 'danger'"
            [class.moodle-site-info--info]="siteInfoStatus(site) === 'info'"
          >
            <nb-icon
              [icon]="
                siteInfoStatus(site) === 'danger'
                  ? 'alert-triangle-outline'
                  : 'info-outline'
              "
            ></nb-icon>
            <div class="moodle-site-info__body">
              <strong>{{ siteStatusKey(site) | translate }}</strong>
              <span>{{ infoKey | translate }}</span>
            </div>
          </div>

          <div *ngIf="canManagePrimarySite" class="moodle-site-settings">
              <div class="settings-group">
                <div class="settings-section__head">
                  <span>{{ "dialogs.moodleConnect.settingsGroupConnection" | translate }}</span>
                </div>

                <div class="settings-row">
                  <nb-icon class="settings-row__icon" icon="star-outline"></nb-icon>
                  <span class="settings-row__label">
                    <span class="settings-row__text">{{ "dialogs.moodleConnect.primarySite" | translate }}</span>
                    <button
                      type="button"
                      class="settings-row__info"
                      [nbTooltip]="'dialogs.moodleConnect.primarySiteTooltip' | translate"
                      [attr.aria-label]="'dialogs.moodleConnect.primarySiteTooltip' | translate"
                    >
                      <nb-icon icon="info-outline"></nb-icon>
                    </button>
                  </span>
                  <nb-toggle
                    size="small"
                    status="primary"
                    [checked]="site.is_primary"
                    [disabled]="siteBusy[site.id] || isSiteDisconnected(site)"
                    (checkedChange)="onPrimaryToggle(site, $event)"
                  ></nb-toggle>
                </div>

                <div class="settings-row">
                  <nb-icon class="settings-row__icon" icon="radio-outline"></nb-icon>
                  <span class="settings-row__label">
                    <span class="settings-row__text">
                      {{
                        (isSitePaused(site)
                          ? 'dialogs.moodleConnect.resumePluginChannel'
                          : 'dialogs.moodleConnect.pausePluginChannel'
                        ) | translate
                      }}
                    </span>
                  </span>
                  <button
                    type="button"
                    class="al-icon-button settings-row__action"
                    [disabled]="siteBusy[site.id] || isSiteDisconnected(site)"
                    [nbSpinner]="siteBusy[site.id]"
                    nbSpinnerSize="tiny"
                    [nbTooltip]="
                      isSitePaused(site)
                        ? ('dialogs.moodleConnect.resumePluginChannelTooltip' | translate)
                        : ('dialogs.moodleConnect.pausePluginChannelTooltip' | translate)
                    "
                    (click)="onPluginChannelAction(site)"
                    [attr.aria-label]="
                      (isSitePaused(site)
                        ? 'dialogs.moodleConnect.resumePluginChannel'
                        : 'dialogs.moodleConnect.pausePluginChannel'
                      ) | translate
                    "
                  >
                    <nb-icon
                      [icon]="isSitePaused(site) ? 'play-circle-outline' : 'pause-circle-outline'"
                    ></nb-icon>
                  </button>
                </div>
              </div>

              <div class="settings-group">
                <div class="settings-section__head">
                  <span>{{ "dialogs.moodleConnect.settingsGroupSync" | translate }}</span>
                </div>

                <div class="settings-row">
                  <nb-icon class="settings-row__icon" icon="person-outline"></nb-icon>
                  <span class="settings-row__label">
                    <span class="settings-row__text">{{ "dialogs.moodleConnect.userPiiSyncShort" | translate }}</span>
                    <button
                      type="button"
                      class="settings-row__info"
                      [nbTooltip]="
                        isSiteDisconnected(site)
                          ? ('dialogs.moodleConnect.userPiiSyncDisconnectedTooltip' | translate)
                          : ('dialogs.moodleConnect.userPiiSyncTooltip' | translate)
                      "
                      [attr.aria-label]="
                        isSiteDisconnected(site)
                          ? ('dialogs.moodleConnect.userPiiSyncDisconnectedTooltip' | translate)
                          : ('dialogs.moodleConnect.userPiiSyncTooltip' | translate)
                      "
                    >
                      <nb-icon icon="info-outline"></nb-icon>
                    </button>
                  </span>
                  <nb-toggle
                    size="small"
                    status="primary"
                    [checked]="!!site.moodle_user_pii_sync_enabled"
                    [disabled]="siteBusy[site.id] || isSiteDisconnected(site)"
                    (checkedChange)="onMoodleUserPiiToggle(site, $event)"
                  ></nb-toggle>
                </div>

                <div
                  *ngIf="site.moodle_user_pii_sync_enabled && site.moodle_user_pii_last_synced_at"
                  class="settings-note"
                >
                  {{ "dialogs.moodleConnect.userPiiLastSync" | translate }}:
                  {{ site.moodle_user_pii_last_synced_at | date:'short' }}
                </div>

                <div class="settings-row">
                  <nb-icon class="settings-row__icon" icon="sync-outline"></nb-icon>
                  <span class="settings-row__label">
                    <span class="settings-row__text">{{ "dialogs.moodleConnect.autoCourseSyncShort" | translate }}</span>
                    <button
                      type="button"
                      class="settings-row__info"
                      [nbTooltip]="
                        isSiteDisconnected(site)
                          ? ('dialogs.moodleConnect.autoCourseSyncDisconnectedTooltip' | translate)
                          : ('dialogs.moodleConnect.autoCourseSyncTooltip' | translate)
                      "
                      [attr.aria-label]="
                        isSiteDisconnected(site)
                          ? ('dialogs.moodleConnect.autoCourseSyncDisconnectedTooltip' | translate)
                          : ('dialogs.moodleConnect.autoCourseSyncTooltip' | translate)
                      "
                    >
                      <nb-icon icon="info-outline"></nb-icon>
                    </button>
                    <span
                      *ngIf="site.auto_course_sync_enabled"
                      class="settings-row__mode"
                    >
                      {{
                        (site.auto_course_sync_mode === "placements"
                          ? "dialogs.moodleConnect.autoCourseSyncModePlacements"
                          : "dialogs.moodleConnect.autoCourseSyncModeAll"
                        ) | translate
                      }}
                    </span>
                  </span>
                  <nb-toggle
                    size="small"
                    status="primary"
                    [checked]="!!site.auto_course_sync_enabled"
                    [disabled]="siteBusy[site.id] || isSiteDisconnected(site)"
                    (checkedChange)="onAutoCourseSyncToggle(site, $event)"
                  ></nb-toggle>
                </div>

                <div
                  class="settings-note"
                  [innerHTML]="'dialogs.moodleConnect.autoCourseSyncQuotaHint' | translate"
                ></div>

                <!-- Speicher freigeben, wenn Auto-Sync schon aus ist (beim
                     Ausschalten fragt der Dialog selbst). Bei aktivem
                     Auto-Sync ausgeblendet: der nächste Lauf füllte die
                     Kurse sofort wieder, der Server lehnt mit 409 ab. -->
                <div *ngIf="!site.auto_course_sync_enabled" class="settings-row">
                  <nb-icon class="settings-row__icon" icon="archive-outline"></nb-icon>
                  <span class="settings-row__label">
                    <span class="settings-row__text">{{ "dialogs.moodleConnect.syncedCoursePurge" | translate }}</span>
                    <button
                      type="button"
                      class="settings-row__info"
                      [nbTooltip]="'dialogs.moodleConnect.syncedCoursePurgeTooltip' | translate"
                      [attr.aria-label]="'dialogs.moodleConnect.syncedCoursePurgeTooltip' | translate"
                    >
                      <nb-icon icon="info-outline"></nb-icon>
                    </button>
                  </span>
                  <!-- Gefahr-Aktion (Spec §12): runder Symbol-Knopf, Rot nur
                       an Symbol und Hover, keine rote Fläche. -->
                  <button
                    type="button"
                    class="al-icon-button settings-row__action settings-row__action--danger"
                    [disabled]="siteBusy[site.id] || purgeBusy[site.id]"
                    [nbSpinner]="purgeBusy[site.id]"
                    nbSpinnerSize="tiny"
                    (click)="onPurgeSyncedCoursesClick(site)"
                    [nbTooltip]="'dialogs.moodleConnect.syncedCoursePurge' | translate"
                    [attr.aria-label]="'dialogs.moodleConnect.syncedCoursePurge' | translate"
                  >
                    <nb-icon icon="trash-2-outline"></nb-icon>
                  </button>
                </div>

                <!-- Forum import: super_admin only while pre-production.
                     Backend rejects non-super_admins too — this *ngIf just
                     keeps the control out of customer views. -->
                <div *ngIf="isSuperAdmin" class="settings-row">
                  <nb-icon class="settings-row__icon" icon="message-square-outline"></nb-icon>
                  <span class="settings-row__label">
                    <span class="settings-row__text">{{ "dialogs.moodleConnect.forumSyncShort" | translate }}</span>
                    <span class="settings-row__mode">
                      {{ "dialogs.moodleConnect.internalOnlyBadge" | translate }}
                    </span>
                  </span>
                  <nb-toggle
                    size="small"
                    status="primary"
                    [checked]="!!site.moodle_forum_sync_enabled"
                    [disabled]="siteBusy[site.id] || isSiteDisconnected(site)"
                    (checkedChange)="onForumSyncToggle(site, $event)"
                  ></nb-toggle>
                </div>

                <!-- One short line under the switch; the long data-protection
                     explanation (and, when on, what happens next) sits behind
                     "Mehr erfahren" instead of several stacked text blocks. -->
                <div *ngIf="isSuperAdmin" class="settings-note">
                  {{
                    (site.moodle_forum_sync_enabled
                      ? "dialogs.moodleConnect.forumSyncActiveShort"
                      : "dialogs.moodleConnect.forumSyncHint"
                    ) | translate
                  }}
                  <button
                    type="button"
                    class="settings-note__more"
                    [nbTooltip]="
                      isSiteDisconnected(site)
                        ? ('dialogs.moodleConnect.forumSyncDisconnectedTooltip' | translate)
                        : site.moodle_forum_sync_enabled
                          ? ('dialogs.moodleConnect.forumSyncTooltip' | translate) + ' ' + ('dialogs.moodleConnect.forumSyncActiveHint' | translate)
                          : ('dialogs.moodleConnect.forumSyncTooltip' | translate)
                    "
                  >
                    {{ "dialogs.moodleConnect.learnMore" | translate }}
                  </button>
                </div>

                <!-- The forum flag is only read INSIDE a course sync, so with
                     content sync off it can be switched on and do nothing at
                     all. Saying so beats leaving somebody to wonder whether it
                     is broken or merely slow. -->
                <div
                  *ngIf="isSuperAdmin && site.moodle_forum_sync_enabled && !site.auto_course_sync_enabled"
                  class="settings-warning"
                  [nbTooltip]="'dialogs.moodleConnect.forumSyncNeedsContentSync' | translate"
                  tabindex="0"
                >
                  <nb-icon icon="alert-triangle-outline"></nb-icon>
                  <span>{{ "dialogs.moodleConnect.forumSyncNeedsContentSyncShort" | translate }}</span>
                </div>

                <!-- Instance-level Kurs-Didaktik: analyse every synced course
                     into chapters/objectives/learning path (guided-mode). -->
                <div class="settings-row">
                  <nb-icon class="settings-row__icon" icon="book-open-outline"></nb-icon>
                  <span class="settings-row__label">
                    <span class="settings-row__text">{{ "dialogs.moodleConnect.structureParseShort" | translate }}</span>
                    <button
                      type="button"
                      class="settings-row__info"
                      [nbTooltip]="'dialogs.moodleConnect.structureParseTooltip' | translate"
                      [attr.aria-label]="'dialogs.moodleConnect.structureParseTooltip' | translate"
                    >
                      <nb-icon icon="info-outline"></nb-icon>
                    </button>
                  </span>
                  <nb-toggle
                    size="small"
                    status="primary"
                    [checked]="!!site.auto_structure_parse_enabled"
                    [disabled]="siteBusy[site.id] || isSiteDisconnected(site)"
                    (checkedChange)="onStructureParseSiteToggle(site, $event)"
                  ></nb-toggle>
                </div>

                <div
                  *ngIf="site.auto_structure_parse_enabled"
                  class="settings-note"
                >
                  {{ "dialogs.moodleConnect.structureParseActiveHint" | translate }}
                </div>
              </div>

              <!-- The customer's consent that agents (portal assistant, Moodle MCP)
                   may change content in this Moodle. Reading needs no switch. -->
              <div class="settings-group">
                <div class="settings-section__head">
                  <span>{{ "dialogs.moodleConnect.settingsGroupAgents" | translate }}</span>
                </div>

                <div class="settings-row">
                  <nb-icon class="settings-row__icon" icon="edit-2-outline"></nb-icon>
                  <span class="settings-row__label">
                    <span class="settings-row__text">{{ "dialogs.moodleConnect.agentWritesShort" | translate }}</span>
                    <button
                      type="button"
                      class="settings-row__info"
                      [nbTooltip]="'dialogs.moodleConnect.agentWritesTooltip' | translate"
                      [attr.aria-label]="'dialogs.moodleConnect.agentWritesTooltip' | translate"
                    >
                      <nb-icon icon="info-outline"></nb-icon>
                    </button>
                  </span>
                  <nb-toggle
                    size="small"
                    status="primary"
                    [checked]="!!site.mcp_admin_enabled"
                    [disabled]="siteBusy[site.id] || isSiteDisconnected(site)"
                    (checkedChange)="onAgentWritesToggle(site, $event)"
                  ></nb-toggle>
                </div>

                <div *ngIf="site.mcp_admin_enabled" class="settings-note">
                  {{ "dialogs.moodleConnect.agentWritesActiveHint" | translate }}
                </div>
              </div>

              <!-- Woher der Fortschritt je Kurs kommt (PRD lms-progress-sources):
                   eine Quelle für alle Kurse dieses Moodle, ohne Rückfall. -->
              <div class="settings-group">
                <div class="settings-section__head">
                  <span>{{ "dialogs.moodleConnect.settingsGroupProgress" | translate }}</span>
                </div>

                <div class="settings-row">
                  <nb-icon class="settings-row__icon" icon="trending-up-outline"></nb-icon>
                  <span class="settings-row__label">
                    <span class="settings-row__text">{{ "dialogs.moodleConnect.progressSourceShort" | translate }}</span>
                    <button
                      type="button"
                      class="settings-row__info"
                      [nbTooltip]="'dialogs.moodleConnect.progressSourceTooltip' | translate"
                      [attr.aria-label]="'dialogs.moodleConnect.progressSourceTooltip' | translate"
                    >
                      <nb-icon icon="info-outline"></nb-icon>
                    </button>
                  </span>
                  <nb-select
                    size="small"
                    [selected]="site.progress_source || 'course_completion'"
                    [disabled]="siteBusy[site.id] || isSiteDisconnected(site)"
                    (selectedChange)="onProgressSourceChange(site, $event)"
                  >
                    <nb-option value="course_completion">
                      {{ "dialogs.moodleConnect.progressSourceCourseCompletion" | translate }}
                    </nb-option>
                    <nb-option value="completion_progress" [disabled]="!canUseCompletionProgress(site)">
                      {{ "dialogs.moodleConnect.progressSourceCompletionProgress" | translate }}
                    </nb-option>
                  </nb-select>
                </div>

                <div *ngIf="site.progress_source === 'completion_progress'" class="settings-note">
                  {{ "dialogs.moodleConnect.progressSourceCompletionProgressActiveHint" | translate }}
                </div>
                <div
                  *ngIf="site.progress_source !== 'completion_progress' && !canUseCompletionProgress(site)"
                  class="settings-note"
                >
                  {{ "dialogs.moodleConnect.progressSourceNeedsPlugin" | translate }}
                </div>

                <div class="settings-row">
                  <nb-icon class="settings-row__icon" icon="search-outline"></nb-icon>
                  <span class="settings-row__label">
                    <span class="settings-row__text">{{ "dialogs.moodleConnect.progressCheckShort" | translate }}</span>
                    <span *ngIf="site.progress_sources_checked_at" class="settings-row__mode">
                      {{ site.progress_sources_checked_at | date:'short' }}
                    </span>
                  </span>
                  <button
                    nbButton
                    size="small"
                    shape="round"
                    status="basic"
                    type="button"
                    [disabled]="progressCheckBusy[site.id] || isSiteDisconnected(site)"
                    [nbSpinner]="progressCheckBusy[site.id]"
                    nbSpinnerSize="tiny"
                    (click)="onCheckProgressSources(site)"
                  >
                    {{ "dialogs.moodleConnect.progressCheck" | translate }}
                  </button>
                </div>

                <div *ngIf="progressSourceInfo(site, 'core_completion') as cc" class="settings-note">
                  {{
                    "dialogs.moodleConnect.progressCheckCourseCompletion"
                      | translate: { courses: cc.courses_with_completion || 0 }
                  }}
                </div>
                <div *ngIf="progressSourceInfo(site, 'completion_progress') as cp" class="settings-note">
                  <ng-container *ngIf="cp.adapter_supported; else cpUnusable">
                    {{
                      "dialogs.moodleConnect.progressCheckCompletionProgress"
                        | translate: { bars: cp.instances_total || 0, courses: cp.courses_with_instances || 0 }
                    }}
                  </ng-container>
                  <ng-template #cpUnusable>
                    {{ ("dialogs.moodleConnect.progressCheckReasons." + (cp.reason || "unknown")) | translate }}
                  </ng-template>
                </div>
              </div>

              <div class="moodle-site-settings__footer">
                <button
                  nbButton
                  size="small"
                  status="danger"
                  shape="round"
                  outline
                  class="moodle-disconnect-button"
                  [disabled]="siteBusy[site.id] || isSiteDisconnected(site)"
                  [nbSpinner]="siteBusy[site.id]"
                  [nbTooltip]="'dialogs.moodleConnect.disconnectTooltip' | translate"
                  (click)="onDisconnectSite(site)"
                  [attr.aria-label]="'dialogs.moodleConnect.disconnectTooltip' | translate"
                >
                  <nb-icon icon="trash-2-outline"></nb-icon>
                  {{ "dialogs.moodleConnect.disconnectShort" | translate }}
                </button>
              </div>
            </div>
        </section>
      </div>
    </div>

    <!-- Legacy manual-token connected state -->
    <div *ngIf="!loading && hasLegacyManualConnection" class="connected-state">
      <div class="status-row">
        <nb-icon icon="checkmark-circle-2-outline" status="success"></nb-icon>
        <div>
          <p class="status-label">{{ "dialogs.moodleConnect.connected" | translate }}</p>
          <p class="status-url">{{ status.api_url }}</p>
        </div>
      </div>

      <!-- Plugin channel pause / resume — distinct from the
           sync_frequency below. This toggle disables only the signed
           plugin heartbeat channel (Moodle Block Plugin → al-tutor).
           Course-content sync into the knowledge base, including the
           re-embedding cadence configured below, keeps running. -->
      <div class="sync-settings" *ngIf="pauseState.total > 0">
        <h6>{{ "dialogs.moodleConnect.pluginChannel" | translate }}</h6>
        <p class="info-text">{{ "dialogs.moodleConnect.pluginChannelInfo" | translate }}</p>
        <div class="status-row" style="margin: 0.5rem 0;">
          <nb-icon
            [icon]="pauseState.paused ? 'pause-circle-outline' : 'checkmark-circle-2-outline'"
            [status]="pauseState.paused ? 'warning' : 'success'"
          ></nb-icon>
          <div>
            <p class="status-label">
              {{
                (pauseState.paused
                  ? 'dialogs.moodleConnect.pluginChannelPaused'
                  : pauseState.mixed
                    ? 'dialogs.moodleConnect.pluginChannelMixed'
                    : 'dialogs.moodleConnect.pluginChannelActive'
                ) | translate
              }}
            </p>
          </div>
        </div>
        <button
          nbButton
          size="small"
          [status]="pauseState.paused ? 'success' : 'primary'"
          outline
          [nbSpinner]="pauseBusy"
          [disabled]="pauseBusy"
          (click)="pauseState.paused ? onResumeIntegration() : onPauseIntegration()"
        >
          <nb-icon
            [icon]="pauseState.paused ? 'play-circle-outline' : 'pause-circle-outline'"
          ></nb-icon>
          {{
            (pauseState.paused
              ? 'dialogs.moodleConnect.resumePluginChannel'
              : 'dialogs.moodleConnect.pausePluginChannel'
            ) | translate
          }}
        </button>
      </div>

      <!-- Sync settings -->
      <div class="sync-settings">
        <h6>{{ "dialogs.moodleConnect.autoSync" | translate }}</h6>
        <p class="info-text">{{ "dialogs.moodleConnect.autoSyncInfo" | translate }}</p>
        <nb-select
          [selected]="syncSettings.sync_frequency"
          (selectedChange)="onSyncFrequencyChange($event)"
          size="small"
        >
          <nb-option value="NEVER">{{ "dialogs.moodleConnect.syncNever" | translate }}</nb-option>
          <nb-option value="DAILY">{{ "dialogs.moodleConnect.syncDaily" | translate }}</nb-option>
          <nb-option value="MONTHLY">{{ "dialogs.moodleConnect.syncMonthly" | translate }}</nb-option>
          <nb-option value="YEARLY">{{ "dialogs.moodleConnect.syncYearly" | translate }}</nb-option>
        </nb-select>
        <p *ngIf="syncSettings.last_auto_sync" class="last-sync-info">
          {{ "dialogs.moodleConnect.lastAutoSync" | translate }}: {{ syncSettings.last_auto_sync | date:'short' }}
        </p>
      </div>

      <button
        nbButton
        status="danger"
        outline
        size="small"
        [nbSpinner]="connecting"
        [disabled]="connecting"
        (click)="onDisconnect()"
      >
        {{ "dialogs.moodleConnect.disconnect" | translate }}
      </button>
    </div>

    <!-- Connection form -->
    <form *ngIf="!loading && showConnectionForm" [formGroup]="form" (ngSubmit)="onConnect()">
      <p class="info-text">{{ "dialogs.moodleConnect.info" | translate }}</p>

      <div class="setup-steps">
        <div class="setup-step">
          <span class="setup-step__index">1</span>
          <span>{{ "dialogs.moodleConnect.setupStepInstall" | translate }}</span>
        </div>
        <div class="setup-step">
          <span class="setup-step__index">2</span>
          <span>{{ "dialogs.moodleConnect.setupStepApiKey" | translate }}</span>
        </div>
        <div class="setup-step">
          <span class="setup-step__index">3</span>
          <span>{{ "dialogs.moodleConnect.setupStepConnect" | translate }}</span>
        </div>
      </div>

      <nb-form-field>
        <label class="label">{{ "dialogs.moodleConnect.urlLabel" | translate }}</label>
        <input
          nbInput
          fullWidth
          formControlName="moodle_url"
          alAnchor="moodle.url"
          placeholder="https://moodle.example.com"
          [status]="showInputError('moodle_url') ? 'danger' : 'basic'"
          autocomplete="off"
          (input)="clearCheckResult()"
        />
        <div *ngIf="showInputError('moodle_url')" class="error-message">
          {{ "dialogs.moodleConnect.urlError" | translate }}
        </div>
      </nb-form-field>

      <nb-form-field>
        <label class="label">{{ "dialogs.moodleConnect.apiKeyLabel" | translate }}</label>
        <div class="api-key-row">
          <nb-select
            fullWidth
            formControlName="api_key"
            alAnchor="moodle.api-key"
            [placeholder]="'dialogs.moodleConnect.apiKeyPlaceholder' | translate"
          >
            <nb-option
              *ngFor="let key of usageService.apiKeys$.value"
              [value]="key.clear_api_key"
            >
              {{ key.name }}
            </nb-option>
          </nb-select>
          <button
            type="button"
            nbButton
            outline
            status="primary"
            [disabled]="!form.value.api_key"
            alAnchor="moodle.copy-key"
            (click)="copySelectedApiKey()"
            [nbTooltip]="'dialogs.moodleConnect.copyApiKey' | translate"
          >
            <nb-icon icon="copy-outline"></nb-icon>
          </button>
        </div>
        <p class="field-hint" *ngIf="hasApiKeys">
          {{ "dialogs.moodleConnect.apiKeyHint" | translate }}
        </p>
        <p class="field-hint" *ngIf="!hasApiKeys">
          {{ "dialogs.moodleConnect.noApiKeys" | translate }}
        </p>
      </nb-form-field>

      <div
        *ngIf="checkResult"
        class="check-result"
        [class.check-result--success]="checkResult.status === 'success'"
        [class.check-result--warning]="checkResult.status === 'warning'"
        [class.check-result--info]="checkResult.status === 'info'"
        [class.check-result--danger]="checkResult.status === 'danger'"
      >
        <nb-icon
          class="check-result__icon"
          [icon]="checkResult.icon"
          [status]="checkResult.status"
        ></nb-icon>
        <div class="check-result__body">
          <p class="check-result__title">{{ checkResult.titleKey | translate }}</p>
          <p class="check-result__message">{{ checkResult.messageKey | translate }}</p>
        </div>
        <button
          type="button"
          nbButton
          ghost
          size="tiny"
          status="basic"
          class="check-result__close"
          [nbTooltip]="'buttons.close' | translate"
          (click)="clearCheckResult()"
        >
          <nb-icon icon="close-outline"></nb-icon>
        </button>
      </div>

    </form>
  </nb-card-body>

  <nb-card-footer>
    <button
      type="button"
      nbButton
      status="danger"
      outline
      (click)="close()"
    >
      {{ "buttons.close" | translate }}
    </button>
    <button
      *ngIf="showConnectionForm && !loading"
      nbButton
      status="primary"
      [nbSpinner]="connecting"
      [disabled]="form.invalid || connecting"
      (click)="onConnect()"
    >
      {{ "dialogs.moodleConnect.checkButton" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
